import styled from "styled-components";

export const ButtonWrapper = styled.button`
    display: block;
    width: 100%;
    border: 0;
    cursor: pointer;
    background-color: ${({ theme }) => theme.color.white};

    a {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .Column {
            &:first-child {
                .AwesomeIcon {
                width: 42px;

                svg {
                    height: 15px;
                    width: auto;

                    path {
                        fill: ${props => props.theme[props.theming]?.colors.location_icon_color};
                    }
                }
            }
            }

            &:last-child {

                .AwesomeIcon {
                    padding-right: 1rem;

                svg {
                    height: 13px;
                    width: auto;

                    path {
                        fill: ${({ theme }) => theme.color.gray};
                    }
                }
            }
            }
        }
    }
`;

export const Column = styled.div`
    display: flex;
    padding: 10px 0;
`;

export const ButtonIcon = styled.div``;

export const Text = styled.div`
    color: ${({ theme }) => theme.color.black};
    font-weight: ${({ theme }) => theme.fontWeight.fw600};
    font-size: 0.8125rem;
    line-height: 2;
`;

export const TextRegular = styled.span`
    color: ${({ theme }) => theme.color.black};
    font-weight: ${({ theme }) => theme.fontWeight.fw400};
    font-size: 0.8125rem;
`;

export const TextBold = styled(TextRegular)`
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
`;
